import { api } from './api'

const apiVersion = 'v2'

export const customerApi = api
    .enhanceEndpoints({
        addTagTypes: ['WebStoreCustomer', 'WebStoreContact'],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            getCustomer: builder.query({
                query: ({ customerId, organisationId }) =>
                    `/${apiVersion}/organisations/${organisationId}/webstorecustomer/${customerId}`,
                providesTags: ['WebStoreCustomer'],
            }),

            getContact: builder.query({
                query: ({ contactId, customerId, organisationId }) =>
                    `/${apiVersion}/organisations/${organisationId}/webstorecustomer/${customerId}/contacts/${contactId}`,
                providesTags: (result, error, arg) => [{ type: 'WebStoreContact', id: arg.contactId }],
            }),

            getContacts: builder.query({
                query: ({ customerId, organisationId }) =>
                    `/${apiVersion}/organisations/${organisationId}/webstorecustomer/${customerId}/contacts`,
                providesTags: (result, _error, _arg) => [
                    { type: 'Contact', id: 'LIST' },
                    ...(result?.map(({ id }) => ({ type: 'WebStoreContact', id })) ?? []),
                ],
            }),

            createCustomer: builder.mutation({
                query: ({ customer, organisationId }) => ({
                    url: `/${apiVersion}/organisations/${organisationId}/webstorecustomer`,
                    method: 'POST',
                    body: customer,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }),
                invalidatesTags: ['WebStoreCustomer'],
            }),

            updateCustomer: builder.mutation({
                query: ({ customer, customerId, organisationId }) => ({
                    url: `/${apiVersion}/organisations/${organisationId}/webstorecustomer/${customerId}`,
                    method: 'PUT',
                    body: customer,
                }),
                async onQueryStarted({ customer, customerId, organisationId }, { dispatch, queryFulfilled }) {
                    dispatch(
                        customerApi.util.updateQueryData('getCustomer', { customerId, organisationId }, (draft) => {
                            Object.assign(draft, customer)
                        })
                    )

                    try {
                        await queryFulfilled
                    } catch {
                        dispatch(customerApi.util.invalidateTags(['WebStoreCustomer']))
                    }
                },
            }),

            createContact: builder.mutation({
                query: ({ contact, customerId, organisationId }) => ({
                    url: `/${apiVersion}/organisations/${organisationId}/webstorecustomer/${customerId}/contacts`,
                    method: 'POST',
                    body: contact,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }),
                invalidatesTags: ['WebStoreContact'],
            }),

            updateContact: builder.mutation({
                query: ({ contact, contactId, customerId, organisationId }) => ({
                    url: `/${apiVersion}/organisations/${organisationId}/webstorecustomer/${customerId}/contacts/${contactId}`,
                    method: 'PUT',
                    body: contact,
                }),
                async onQueryStarted({ contact, contactId, customerId, organisationId }, { dispatch, queryFulfilled }) {
                    dispatch(
                        customerApi.util.updateQueryData(
                            'getContact',
                            { contactId, customerId, organisationId },
                            (draft) => {
                                Object.assign(draft, contact)
                            }
                        )
                    )

                    try {
                        await queryFulfilled
                    } catch {
                        dispatch(customerApi.util.invalidateTags(['WebStoreContact']))
                    }
                },
            }),
        }),
    })

export const {
    useCreateContactMutation,
    useCreateCustomerMutation,
    useGetContactQuery,
    useGetContactsQuery,
    useGetCustomerQuery,
    useLazyGetContactQuery,
    useLazyGetCustomerQuery,
    useUpdateContactMutation,
    useUpdateCustomerMutation,
} = customerApi
